define('shared/util/dom/expression/AttrSearcher',[],function () {
    var ATTRS = {
        'href': true,
        'src': true,
        'data-die': true,
        'class': true
    };

    var REGEX_SEARCH = /\$\{([\s\S]*?)\}/g;

    function Ctor( $el ){
        this.$el = $el;
        this.nodes = [];
    }

    var p = Ctor.prototype;
    p.search = function () {
        var el = this.$el[0];
        var attribs = el.attributes;
        var match;
        var nodeInfo;
        var attr;
        var value;
        var prefix;
        this.nodes = [];

        for(var l = attribs.length; l--; ) {
            attr = attribs[l];

            if ( !(attr.nodeName in ATTRS) ) {
                continue;
            }

            value = attr.nodeValue;
            value = decodeURI(value);

            if ( value.search(REGEX_SEARCH) < 0 ) {
                continue;
            }

            REGEX_SEARCH.lastIndex = 0;

            nodeInfo = {
                node: attr,
                keys: []
            };

            while( match = REGEX_SEARCH.exec( value ) ) {
                if ( match.length < 2 ) {
                    continue;
                }
                nodeInfo.keys.push( match[1] );
            }

            attr.nodeValue = value;
            this.nodes.push(nodeInfo);
        }

        return this.nodes;
    };
    return Ctor;
});
